import ChatType from '@/shared/constants/ChatType';
import { BaseEvent } from '@/shared/utils/EventBus';
import ChatMentionTarget from './ChatMentionTarget';
import ChatMessage from './ChatMessage';

export class ChatMentionSelected extends BaseEvent {
  constructor(
    readonly target: ChatMentionTarget,
  ) {
    super();
  }
}

export class InsertChatContent extends BaseEvent {
  constructor(
    readonly content: string,
  ) {
    super();
  }
}

export class ChatMessageAdded extends BaseEvent {
  constructor(
    readonly message: ChatMessage,
    readonly type: ChatType,
  ) {
    super();
  }
}
